import React, { FC, useState, useEffect, useContext } from 'react'
import _ from 'lodash'
import Loading from 'live/components/ui/Loading'
import QueryContext from './Utils/queryContext'
import SolidGauge from './components/ChartGauge'
import { DashboardContext } from 'live/context/dashboard'
import get from 'lodash/get'
import { WaitingEvents } from '../../../utils/WaitingEvents'

export default function Widget({ widget, state, height, width }) {
    const { jsonConfig } = widget || {}
    const { loading, value } = state || {}

    if (loading) return <Loading />
    if (value?.value?.length < 1) return <WaitingEvents />

    const consumerData = useContext(DashboardContext)
    const dashTheme = get(consumerData, 'theme', 'light')
    const [valueContext, setValueContext] = useState({})

    useEffect(() => setValueContext({ theme: dashTheme }), [dashTheme])

    return (
        <QueryContext.Provider value={{ valueContext, setValueContext }}>
            <SolidGauge event={value} config={jsonConfig} height={height} width={width} />
        </QueryContext.Provider>
    )
}
